import { isDashboardOrgSegment, readDashboardOrgCookie } from "@/lib/dashboardOrg";
import { peekOneOrgContext } from "@/lib/ensureOneOrgContext";

/** Same org key One and Agents use for KB registry localStorage + cookie sync. */
export function resolveKnowledgeOrgId(sessionOrgId: string | null | undefined): string | null {
  const fromSession = (sessionOrgId || "").trim();
  if (isDashboardOrgSegment(fromSession)) return fromSession;
  const fromCtx = peekOneOrgContext()?.orgId;
  if (fromCtx) return fromCtx;
  const fromCookie = readDashboardOrgCookie();
  if (fromCookie) return fromCookie;
  return null;
}
